import React, { useState } from "react";
import { Grid } from "@mui/material";

import { useTranslation } from "react-i18next";
import Survey from "./Survey";
import Completed from "./Completed";
import HeaderImage from "../components/HeaderImage";
import Header from "../components/Header";
import { SURVEY_IDS } from "../utils/constants";

const RenaultMaster = (props) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const { t } = useTranslation();

  {
    document.title = " RENAULT MASTER ";
  }

  const surveyId = SURVEY_IDS.RENAULT_MASTER;

  return (
    <Grid container>
      <Header model={"renaultMaster"} />
      <HeaderImage model={"renaultMaster"} />

      {isCompleted ? <Completed /> : <Survey setIsCompleted={setIsCompleted} surveyId={surveyId} />}
    </Grid>
  );
};

export default RenaultMaster;
